import Icon from '@/components/ui/AppIcon';

interface ProcessStep {
  id: number;
  title: string;
  description: string;
  icon: string;
  chemistry: string;
}

const processSteps: ProcessStep[] = [
  {
    id: 1,
    title: 'Pre-Treatment',
    description: 'Zirconium-based conversion coating creates superior adhesion foundation with enhanced corrosion resistance.',
    icon: 'BeakerIcon',
    chemistry: 'Zr(OH)₄ Conversion'
  },
  {
    id: 2,
    title: 'Powder Application',
    description: 'Electrostatic spray technology ensures uniform coating distribution with optimal film thickness control.',
    icon: 'BoltIcon',
    chemistry: 'Electrostatic Deposition'
  },
  {
    id: 3,
    title: 'Thermal Cure',
    description: 'Precision temperature profiling achieves complete cross-linking for maximum durability and finish quality.',
    icon: 'FireIcon',
    chemistry: 'Polymer Cross-Linking'
  },
  {
    id: 4,
    title: 'Quality Verification',
    description: 'Multi-point inspection protocol validates adhesion, thickness, appearance, and performance specifications.',
    icon: 'ShieldCheckIcon',
    chemistry: 'Performance Testing'
  }
];

const ProcessOverview = () => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-secondary/10 rounded-full mb-4">
            <Icon name="CogIcon" size={20} variant="outline" className="text-secondary" />
            <span className="text-sm font-cta font-semibold text-secondary">
              Four-Stage Excellence
            </span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-headline font-bold text-foreground mb-4">
            Engineered Coating Process
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            Every coating cycle follows our proven four-stage methodology, combining advanced chemistry with precision process control.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {processSteps.map((step, index) => (
            <div
              key={step.id}
              className="relative bg-card rounded-lg p-6 shadow-md hover:shadow-lg transition-all duration-base border border-border"
            >
              <div className="absolute -top-4 left-6 w-12 h-12 bg-primary rounded-lg flex items-center justify-center shadow-md">
                <Icon name={step.icon as any} size={24} variant="solid" className="text-primary-foreground" />
              </div>

              <div className="mt-6">
                <div className="flex items-center justify-between mb-3">
                  <h3 className="text-xl font-headline font-bold text-foreground">
                    {step.title}
                  </h3>
                  <span className="text-sm font-cta font-bold text-accent">
                    Step {index + 1}
                  </span>
                </div>

                <p className="text-sm text-muted-foreground mb-4 leading-relaxed">
                  {step.description}
                </p>

                <div className="pt-4 border-t border-border">
                  <div className="text-xs font-accent text-secondary font-medium">
                    {step.chemistry}
                  </div>
                </div>
              </div>

              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 transform -translate-y-1/2">
                  <Icon name="ChevronRightIcon" size={24} variant="outline" className="text-border" />
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessOverview;